/**
 * @file 讲义打印页
 * @description 侧栏「讲义打印」对应页面。
 *
 * @whenToUse 路由 `/handouts`。
 * @whenNotToUse 其他业务菜单页。
 */

import { Empty } from '@/components/ui/empty.tsx'
import { PageHeader } from '@/components/ui/page-header.tsx'

export function HandoutPage() {
  return (
    <>
      <PageHeader
        title="讲义打印"
        description="管理讲义打印任务与记录。"
      />
      <div className="mt-6 rounded-2xl border border-border bg-surface p-6">
        <Empty description="讲义打印待接入" />
      </div>
    </>
  )
}
